import { Link } from 'react-router-dom';
import { categories } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer className="bg-background-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="flex flex-col lg:flex-row gap-10">
          <div className="lg:w-1/4">
            <Link to="/" className="inline-block mb-4">
              <span className="font-heading text-2xl font-bold text-primary-500">
                每日黑料
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              每日黑料——全网最快、最全、最真实的娱乐爆料平台。覆盖网红塌房、明星黑料、吃瓜大赛等热门内容，吃瓜群众必备入口。
            </p>
          </div>

          <div className="flex-1 grid grid-cols-2 sm:grid-cols-3 gap-8">
            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4 uppercase tracking-wider">
                内容分类
              </h4>
              <div className="flex flex-col gap-2.5">
                {categories.slice(0, 4).map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4 uppercase tracking-wider">
                更多分类
              </h4>
              <div className="flex flex-col gap-2.5">
                {categories.slice(4).map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                  >
                    {cat.name}
                  </Link>
                ))}
                <Link
                  to="/about"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                >
                  关于我们
                </Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4 uppercase tracking-wider">
                联系方式
              </h4>
              <div className="flex flex-col gap-2.5">
                <span className="text-sm text-foreground-600">
                  <i className="ri-mail-line mr-2"></i>
                  hello@66012.cn
                </span>
                <span className="text-sm text-foreground-600">
                  <i className="ri-phone-line mr-2"></i>
                  400-888-6666
                </span>
                <span className="text-sm text-foreground-600">
                  <i className="ri-map-pin-line mr-2"></i>
                  北京市朝阳区
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-300/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <span>&copy; 2026 每日黑料 版权所有</span>
            <span className="hidden sm:inline text-foreground-400">|</span>
            <a href="#" className="hover:text-primary-500 transition-colors">隐私政策</a>
            <span className="hidden sm:inline text-foreground-400">|</span>
            <a href="#" className="hover:text-primary-500 transition-colors">使用条款</a>
            <span className="hidden sm:inline text-foreground-400">|</span>
            <a href="#" className="hover:text-primary-500 transition-colors">免责声明</a>
          </div>
          <div className="flex items-center gap-3">
            <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="微博">
              <i className="ri-weibo-line"></i>
            </a>
            <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="微信">
              <i className="ri-wechat-line"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}